import { API } from 'aws-amplify';
import CreatePostArgs from '../_types/CreatePostArgs';
import { LOG } from '../../../common/Utilities';

const FEED_BLAST = /* GraphQL */ `
  mutation FeedBlast(
    $header: String!
    $details: String!
    $imageName: String!
    $imageType: String!
    $blastEvent: String!
    $userID: String!
    $chartType: String
    $chartData: String
    $alertMessage: String
    $alertDetails: String
    $createdBy: String!
    $ccUserID: String!
    $feedType: String
    $showAfterEpoch: Float
    $showUntilEpoch: Float
  ) {
    feedBlast(
      header: $header
      details: $details
      imageName: $imageName
      imageType: $imageType
      blastEvent: $blastEvent
      userID: $userID
      chartType: $chartType
      chartData: $chartData
      alertMessage: $alertMessage
      alertDetails: $alertDetails
      createdBy: $createdBy
      ccUserID: $ccUserID
      feedType: $feedType
      showAfterEpoch: $showAfterEpoch
      showUntilEpoch: $showUntilEpoch
    )
  }
`;

const feedBlast = async (
  args: CreatePostArgs & {
    userID: string;
    header: string;
    details: string;
    imageName: string;
    imageType: string;
    blastEvent: any;
    mySub?: string;
    chartType?: string;
    chartData?: string;
    alertMessage: string;
    alertDetails: string;
    createdBy: string;
    ccUserID: string;
    feedType: string;
    showAfterEpoch: number;
    showUntilEpoch: number;
  }
) => {
  try {
    const feedBlastVars = {
      ...args,
      blastEvent:
        args.blastEvent === undefined
          ? JSON.stringify({})
          : JSON.stringify(args.blastEvent),
      userID: args.mySub === undefined ? '' : args.mySub,
      chartType: args.chartType === undefined ? '' : args.chartType,
      chartData: args.chartData === undefined ? '' : args.chartData,
    };

    await API.graphql({
      query: FEED_BLAST,
      variables: feedBlastVars,
    });

    return true;
  } catch (err) {
    LOG.error('circleFeedBlast Error: ' + err);
    return false;
  }
};

export default feedBlast;
